import { buildUrl, getOptions } from "./commonService";
import axios from "axios";
import {
  ADMIN_API_CHECK_EVU,
  TIIVII_CREATE_ROOM_TEMPLATE_ENDPOINT,
  TIIVII_UPDATE_ROOM_TEMPLATE_ENDPOINT,
} from "../utils/constants";

export const checkEvuService = body => {
  const options = getOptions({});

  if (options.headers && options.headers["Content-Type"]) {
    delete options.headers["Content-Type"];
  }

  return axios.post(ADMIN_API_CHECK_EVU, body, {
    ...options,
    headers: {
      ...options.headers,
      Accept: "application/json",
    },
  });
};

export const createRoomTemplateService = (contract_id, body) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_CREATE_ROOM_TEMPLATE_ENDPOINT, { contract_id });

  if (options.headers && options.headers["Content-Type"]) {
    delete options.headers["Content-Type"];
  }

  return axios.post(url, body, {
    ...options,
    headers: {
      ...options.headers,
      Accept: "application/json",
    },
  });
};

export const updateRoomTemplateService = (contract_id, room_id, body) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_UPDATE_ROOM_TEMPLATE_ENDPOINT, { contract_id, room_id });

  if (options.headers && options.headers["Content-Type"]) {
    delete options.headers["Content-Type"];
  }

  return axios.patch(url, body, {
    ...options,
    headers: {
      ...options.headers,
      Accept: "application/json",
    },
  });
};
